import { Box, Flex, Text, chakra } from '@chakra-ui/react';
import { X } from 'lucide-react';
import { Input } from '@/components/ui/Input/Input';
import type { OnboardingFormReturn } from '../useOnboardingForm';

export function SkillsStep({ form }: { form: OnboardingFormReturn }) {
  const { skills, newSkill, setNewSkill, handleAddSkill, handleDeleteSkill } = form;
  return (
    <Flex direction="column" gap="4">
      <Text fontSize="md" color="volyx.textSecondary">
        Add a few skills you can offer organizations. Press Enter or tap Add to save each one.
      </Text>
      <Flex gap="2">
        <Input
          id="onboarding-new-skill"
          name="onboarding-new-skill"
          autoComplete="off"
          value={newSkill}
          onChange={(e) => setNewSkill(e.target.value)}
          placeholder="e.g. First aid, photography, translation..."
          maxLength={25}
          onKeyPress={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault();
              handleAddSkill();
            }
          }}
        />
        <chakra.button
          px="6"
          py="3"
          borderRadius="xl"
          fontWeight="semibold"
          transition="all 0.3s"
          cursor="pointer"
          border="none"
          bg="volyx.lightGray"
          color="volyx.text"
          _hover={{ bg: 'volyx.mediumGray', transform: 'scale(1.01)' }}
          onClick={handleAddSkill}
        >
          Add
        </chakra.button>
      </Flex>
      <Box minH="120px">
        {skills.length === 0 ? (
          <Text color="volyx.textSecondary" fontSize="sm">No skills added yet.</Text>
        ) : (
          <Flex direction="column" gap="2">
            {skills.map((skill) => (
              <Flex
                key={skill}
                align="center"
                justify="space-between"
                bg="volyx.lightGray"
                borderRadius="lg"
                px="4"
                py="2"
              >
                <Text as="span" color="volyx.primary" fontSize="md">{skill}</Text>
                <chakra.button
                  bg="transparent"
                  border="none"
                  cursor="pointer"
                  color="volyx.textSecondary"
                  p="1"
                  borderRadius="md"
                  _hover={{ color: 'volyx.error', bg: 'white' }}
                  onClick={() => handleDeleteSkill(skill)}
                  aria-label={`Remove ${skill}`}
                >
                  <X size={14} />
                </chakra.button>
              </Flex>
            ))}
          </Flex>
        )}
      </Box>
    </Flex>
  );
}
